// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"b53d3313a469a7c0e987","418":"9f369b1064b48276432e","865":"b53d3313a469a7c0e987","886":"b53d3313a469a7c0e987","6153":"b53d3313a469a7c0e987","7364":"b53d3313a469a7c0e987"}[chunkId] + ".chunk.css";
};